var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStreamlinedEfficiency(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.63818 31.588L4.72786 32.6443L5.78417 29.5547",
    stroke: "#667085",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.73787 32.644C2.38525 29.3641 1 25.3438 1 20.9995C1 9.95407 9.95407 1 20.9995 1C25.3438 1 29.3641 2.38525 32.644 4.73787",
    stroke: "#667085",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.3603 10.4123L37.2707 9.35608L36.2144 12.4457",
    stroke: "#667085",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2616 9.35608C39.6143 12.636 40.9995 16.6563 40.9995 21.0007C40.9995 32.0461 32.0454 41.0001 21 41.0001C16.6557 41.0001 12.6354 39.6149 9.35547 37.2623",
    stroke: "#667085",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M34.877 23.8681V18.1258H31.1309C30.9057 17.3296 30.5885 16.5719 30.1927 15.8644L32.8426 13.2145L28.7822 9.15409L26.1323 11.804C25.4248 11.4082 24.6672 11.091 23.871 10.8658V7.11975H18.1287V10.8658C17.3325 11.091 16.5748 11.4082 15.8674 11.804L13.2174 9.15409L9.15706 13.2145L11.807 15.8644C11.4111 16.5719 11.094 17.3295 10.8688 18.1258H7.12256V23.8681H10.8686C11.0938 24.6643 11.411 25.422 11.8068 26.1294L9.1569 28.7794L13.2173 32.8397L15.8672 30.1898C16.5748 30.5856 17.3323 30.9028 18.1286 31.128V34.8741H23.8709V31.128C24.6671 30.9028 25.4248 30.5856 26.1322 30.1898L28.7822 32.8397L32.8425 28.7794L30.1926 26.1294C30.5884 25.4219 30.9056 24.6643 31.1308 23.8681H34.877Z",
    stroke: "#667085",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9997 28.019C24.8769 28.019 28.0199 24.8759 28.0199 20.9987C28.0199 17.1216 24.8769 13.9785 20.9997 13.9785C17.1226 13.9785 13.9795 17.1216 13.9795 20.9987C13.9795 24.8759 17.1226 28.019 20.9997 28.019Z",
    stroke: "#667085",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9995 17.3281V21.0015H23.8566",
    stroke: "#667085",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStreamlinedEfficiency);
export default __webpack_public_path__ + "static/media/StreamlinedEfficiency.ae9f082cf5ef49b86a4b6e40c866f505.svg";
export { ForwardRef as ReactComponent };